import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "~/components/components/cards/CardImageTile.css";
import { IImage, Image } from "~/components/elements/Image";
import { Link } from "~/components/elements/Link";

export type CardImageTileProps = ComponentPropsWithoutRef<"div"> &
  PropsWithChildren & {
    image: IImage;
    link?: {
      slug: string;
      _type: string;
      type?: "internal" | "external";
    };
    width?: number;
    loading?: "eager" | "lazy";
    className?: string;
  };

export const CardImageTile = ({
  image,
  link,
  width = 500,
  loading = "eager",
  className,
  ...props
}: CardImageTileProps) => {
  const imageElement = (
    <Image
      image={image}
      width={width}
      loading={loading}
      className={styles.image}
    />
  );

  if (link) {
    return (
      <Link
        className={styles.card}
        _type="link"
        slug={link.slug}
        type={link.type === "external" ? "external" : "internal"}
        newTab={link.type === "external"}
        {...props}
      >
        {imageElement}
      </Link>
    );
  }

  return (
    <div className={styles.card} {...props}>
      {imageElement}
    </div>
  );
};
